import type { FC } from 'react';
import React from 'react';
import type { TypographyProps } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';

export const OneLineTypography: FC<TypographyProps> = ({
  children,
  ...otherProps
}) => {
  return (
    <Typography
      {...otherProps}
      noWrap
      sx={[
        {
          lineHeight: 1,
        },
        ...(Array.isArray(otherProps.sx) ? otherProps.sx : [otherProps.sx]),
      ]}
    >
      {children}
    </Typography>
  );
};
